export default __webpack_public_path__ + "static/media/TotemUso20.d0f30fdf.jpg";